
import XHeader from 'vux/src/components/x-header/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import store from '../../vuex/store'
export default {
components: {
Tab,
TabItem,
XInput,
XButton,
Group,
XSwitch,
XHeader,
Alert,
Toast,
Loading
},
data () {
return {
loadingShow: false,
loadingText: '保存中',
pullHeight: window.innerHeight,
showClear: false,
show: true,
warnMsgShow: false,
warnMsg: '',
toastShow: false,
toastMsg: '',
type: 1,
card1: {
isDefault: false,
address: '',
bankAccount: '',
depositBank: '',
email: '',
id: '',
mobile: '',
name: '',
taxpayerNo: '',
telephone: '',
type: 1
},
card2: {
isDefault: false,
email: '',
mobile: '',
name: '',
type: 0
}
}
},
mounted () {
store.commit( 'UPDATE_TITLE', '发票名片' )
},
created () {
store.commit( 'UPDATE_SHOW_FOOTER', false )
},
methods: {
onClick ( link ) {
var _this = this
var param = {}
if ( _this.type === 0 ) {
param = _this.card2
} else {
param = _this.card1
}
if ( param.name === '' ) {
_this.warnMsgShow = true
_this.warnMsg = '名称不能为空'
return false
}
if ( !param.name.match( '[\\u4e00-\\u9fa5\\da-zA-Z()]{2,40}' ) ) {
_this.warnMsgShow = true
_this.warnMsg = '名称格式不正确'
return false
}
if ( param.mobile && !param.mobile.match( /^1\d{10}$/ ) ) {
_this.warnMsgShow = true
_this.warnMsg = '手机号格式不正确'
return false
}
if ( param.email && !param.email.match( /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/ ) ) {
_this.warnMsgShow = true
_this.warnMsg = '邮箱格式不正确'
return false
}
if ( param.email.length > 50 ) {
_this.warnMsgShow = true
_this.warnMsg = '邮箱长度不正确'
return false
}
if ( param.taxpayerNo && !param.taxpayerNo.match( '(^$)|([\\dA-Z]{15,20})' ) ) {
_this.warnMsgShow = true
_this.warnMsg = '税号格式不正确'
return false
}
if ( param.address ) {
if ( !param.address.match( '(^$)|([\\u4e00-\\u9fa5\\da-zA-Z()\\s\\-_、.#]{1,50})' ) || param.address.length > 50 ) {
_this.warnMsgShow = true
_this.warnMsg = '地址格式不正确'
return false
}
}
if ( param.telephone && !param.telephone.match( /[0-9-]{7,20}/ ) ) {
_this.warnMsgShow = true
_this.warnMsg = '电话号码格式不正确'
return false
}
if ( param.depositBank && !param.depositBank.match( '(^$)|([\\u4e00-\\u9fa5\\w（）()]{1,50})' ) ) {
_this.warnMsgShow = true
_this.warnMsg = '开户银行名称格式不正确'
return false
}
if ( param.bankAccount && !param.bankAccount.match( '(^$)|([\\-\\w]{8,50})' ) ) {
_this.warnMsgShow = true
_this.warnMsg = '银行账号格式不正确'
return false
}
_this.loadingShow = true
_this.$ajax.post( _this.ajaxFactory.get( 'saveBusinessCard' ), {}, {
params: param
} ).then( function ( response ) {
var result = response.data
_this.loadingShow = false
if ( result.code === '200' ) {
_this.toastShow = true
_this.toastMsg = '保存成功'
setTimeout( function () {
window.history.go( -1 )
}, 3000 )
} else {
_this.warnMsgShow = true
_this.warnMsg = result.msg
}
} )
.catch( function ( response ) {
_this.loadingShow = true
console.log( response )
} )
},
onShowConfirm ( item ) {
}
}
}



// WEBPACK FOOTER //
// ./src/components/card/addCard.vue